/*eslint-disable*/
// @ts-nocheck
/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "tumelo.transparency.v1";

/** OrganizationAddress is an address for an organization */
export interface OrganizationAddress {
  /** REQUIRED iso 2 country code */
  countryCodeIso2: string;
}

function createBaseOrganizationAddress(): OrganizationAddress {
  return { countryCodeIso2: "" };
}

export const OrganizationAddress = {
  encode(message: OrganizationAddress, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.countryCodeIso2 !== "") {
      writer.uint32(10).string(message.countryCodeIso2);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OrganizationAddress {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationAddress();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.countryCodeIso2 = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationAddress {
    return { countryCodeIso2: isSet(object.countryCodeIso2) ? String(object.countryCodeIso2) : "" };
  },

  toJSON(message: OrganizationAddress): unknown {
    const obj: any = {};
    if (message.countryCodeIso2 !== "") {
      obj.countryCodeIso2 = message.countryCodeIso2;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrganizationAddress>, I>>(base?: I): OrganizationAddress {
    return OrganizationAddress.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrganizationAddress>, I>>(object: I): OrganizationAddress {
    const message = createBaseOrganizationAddress();
    message.countryCodeIso2 = object.countryCodeIso2 ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
